export default __webpack_public_path__ + "static/media/LCA__TAM_0280.829abea3.jpg";